import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyFileMediaInfoDto } from 'src/app/models/Study/study-file.model';
import { CommonModule } from '@angular/common';
import videojs from 'video.js';
import { NextFrameButton, PrevFrameButton } from './frame-by-frame-button.component';

@Component({
  selector: 'video-modal',
  standalone: true,
  imports: [ CommonModule ],
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
})

export class VideoModalComponent implements OnInit, AfterViewInit, OnDestroy {
  public videoTitle: string = null;
  private _videoInfo: StudyFileMediaInfoDto;
  private static componentsRegistered = false;
  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef;
  player: any;

  ngAfterViewInit() {
    this.initializePlayerIfReady();
  }

  /**
   * Attaches video.js, once, and only when the player element is really in the DOM.
   * The element sits behind *ngIf="isVideoAvailable", so it does not exist yet when the modal
   * opens on a file that is still converting.
   */
  private initializePlayerIfReady(): void {
    if (this.player || !this.isVideoAvailable || !this.videoPlayer) {
      return;
    }
    this.player = videojs(this.videoPlayer.nativeElement, {
      autoplay: true,
      controls: true,
      fluid: true,
      controlBar: {
        children: [
          'playToggle',
          'volumePanel',
          'progressControl',
          'PrevFrameButton',
          'NextFrameButton',
          'playbackRateMenuButton',
          //'pictureInPictureToggle',
          'fullscreenToggle'
        ]
      },
      playbackRates: [0.5, 1, 1.5, 2],
      preload: 'auto',
      muted: true
    });
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }

  @Input() set videoInfo(value: StudyFileMediaInfoDto) {
    const wasAvailable = this._videoInfo?.isConverted === true;
    this._videoInfo = value;
    if(this.videoTitle === null) {
      this.videoTitle = value.videoTitle; //set only once.
    }
    // When the modal opens on a file that is still converting, the conversion poll sets this input
    // long after ngAfterViewInit has run. Without re-attaching here the *ngIf renders a bare
    // <video>: first frame paints, but there are no controls and nothing plays. Defer a tick so
    // the element exists before we attach.
    if (!wasAvailable && value?.isConverted) {
      setTimeout(() => this.initializePlayerIfReady(), 0);
    }
  }

  get VideoInfo(): StudyFileMediaInfoDto {
    return this._videoInfo;
  }

  constructor(public modal: NgbActiveModal) {
    if (!VideoModalComponent.componentsRegistered) {
      videojs.registerComponent('NextFrameButton', NextFrameButton);
      videojs.registerComponent('PrevFrameButton', PrevFrameButton);
      VideoModalComponent.componentsRegistered = true;
    }
  }

  ngOnInit(): void { }

  closePopup(): void {
    this.modal.close();
  }

  get isVideoAvailable(): boolean {
    return this._videoInfo?.isConverted;
  }

  get conversionMessage(): string {
    return this._videoInfo?.conversionMessage;
  }
}
